/*====================================
=            App Settings            =
====================================*/

// Some settings are included in the root .env file
// but this does not load with Javascript applications without dotenv (which I cannot get to work!) can only be run in the webpack build.
// https://alligator.io/vuejs/working-with-environment-variables/

let BASE_DOMAIN = 'sdg-hosting.com' // window.location.origin

let MAP = {
  'PROVIDER'       : 'GOOGLE',
  'API_KEY'        : 'AIzaSyC_W5KpNHoWYOrK5OSvNmFZDiTG1CNYr5w', // client must provide the Google API key
  'START_LOCATION' : { lat: 37.35, lng: -121.95 },
  'START_ZOOMLEVEL': 13,
}

let AUTOCOMPLETE_BOUNDS = {north: 38, south: 36.5, east: -121, west: -123}
let AUTOCOMPLETE_COUNTRYCODE = 'us'

let DATETIME = {
  'DATEPICKER_FORMAT'  : 'ddd, MMM.DD', // http://momentjs.com/docs/#/displaying/format/
  'TIMEPICKER_FORMAT'  : 'h:mm a',
  'TIMEPICKER_FORMAT2' : 'YYYY-MM-DDTHH:mm',
  'DATE_ISO8601_FORMAT': 'YYYY-MM-DD',
  'TIME_ISO8601_FORMAT': 'HH:mm',
  'TIME_ZONE'          : 'America/Los_Angeles',
  'MOMENT_TIME_ZONE'   : 'America/Los_Angeles|PST PDT|80 70|0101|1Lzm0 1zb0 Op0',
}

if (location.href.indexOf('localhost') > -1 && process.env.NODE_ENV !== 'production') {
  BASE_DOMAIN = 'localhost'
  MAP.API_KEY = 'AIzaSyDF3DU0RinU4aII2kP9_1yZacBBiVmYBn8'
}

export {
  AUTOCOMPLETE_BOUNDS,
  AUTOCOMPLETE_COUNTRYCODE,
  BASE_DOMAIN,
  DATETIME,
  MAP
}

export default {
  AUTOCOMPLETE_BOUNDS,
  AUTOCOMPLETE_COUNTRYCODE,
  BASE_DOMAIN,
  DATETIME,
  MAP
}

/* WARNING! The .htaccess file in the public folder that ships with Laravel actually strips the trailing slash from urls,
   so if no other path parameters make sure you remove the trailing slash.
*/



// WEBPACK FOOTER //
// ./src/config/index.js